import { Spinner } from 'components/spinner/Spinner';
import { useLockBody } from 'hooks/useLockBody';
import React, { useState, useEffect } from 'react';
import { BlockCopyandPaste } from 'helpers/blockCopyandPaste';

type PopoutMenuProps = {
  isPopup: boolean;
  isOpen: boolean;
  handleClose: () => void;
  className?: string;
  position: 'left' | 'right';
  setTop?: boolean;
  noBackground?: boolean;
  width?: number;
  minWidth?: number;
  mobileMenu?: boolean;
  loading?: boolean;
  error?: boolean;
  zIndexVal?: number;
  noOverflowToggle?: boolean;
  children?: any;
};

const OPEN_CLASS = 'Open';

export const PopoutMenu: React.FC<PopoutMenuProps> = ({
  isPopup,
  isOpen,
  handleClose,
  className,
  position,
  setTop,
  noBackground,
  width,
  minWidth,
  mobileMenu,
  children,
  loading,
  error,
  zIndexVal,
  noOverflowToggle,
}) => {
  const [noChildren, setNoChildren] = useState<any>();
  const [openCloseState, setOpenCloseState] = useState<string>('Closed');
  const openCloseTime = isPopup ? 100 : 250;

  useEffect(() => {
    setOpenCloseState('Opening');

    let _safariStr = navigator.userAgent.toLowerCase();
    let _safari = ((_safariStr.indexOf("safari") != -1) && (_safariStr.indexOf("chrome") === -1)) ? true : false;  
    var is_iOS = navigator.userAgent.match(/(iPhone|iPod|iPad)/i);

    if (isOpen) {
      if(!_safari && !is_iOS && !noOverflowToggle){
        document.body.style.overflowY = 'hidden';
      }
 
      setNoChildren(false);

      setTimeout(function () {
        setOpenCloseState('Open');
      }, openCloseTime);
    } else {
      document.body.style.overflowY = '';
      setOpenCloseState('Closing');

      setTimeout(function () {
        setNoChildren(true);
        setOpenCloseState('Closed');
      }, openCloseTime);
    }
  }, [isOpen]);

  const lock = useLockBody(isOpen);

  useEffect(() => {
    if(children){
      BlockCopyandPaste();
    }
  }, [children]);  
    
  let styleObj: any = {};

  if(zIndexVal){
    styleObj.zIndex = zIndexVal;
  }

  return (
    <div
      className={`PopoutContainer ${
        isPopup ? ' Popup' : ' Panel'
      } ${openCloseState}`}
      style={styleObj}
    >
      <div className={"Inner" + (setTop ? " SetTop" : "")}>
        {!noBackground &&
          <div
            className={`PopoutMenuBackground ${openCloseState}`}
            onClick={handleClose}
          />        
        }
        <div
          className={`PopoutMenu ${className ?? ''} 
            ${isPopup ? 'Popup' : 'Panel'} 
            ${openCloseState} 
            ${position ? position : ''} 
            ${mobileMenu ? 'MobileMenu' : ''}
            ${noBackground ? 'NoFade' : ''}`}
          style={{
            width: width ? width + 'px' : '560px',
            minWidth: minWidth ? minWidth + 'px' : '320px',
          }}
        >
          {loading && <Spinner color={'#f59e16'} />}
          {error && (
            <div>Oops, something went wrong. Please try again later.</div>
          )}
          {noChildren ? null : children}
        </div>
      </div>
    </div>
  );
};
